import { FC } from "react";

import save from "../Img/save.svg";
import refresh from "../Img/revert.svg";
import warning from "../Img/warning.svg";

import ActivationLimitEditorButton from "./ActivationLimitEditorButton";

interface ActivationLimitEditorActionButtonsProps {
    onSave: () => void;
    onReset: () => void;
    disabled?: boolean;
}

const ActivationLimitEditorActionButtons: FC<
    ActivationLimitEditorActionButtonsProps
> = ({ onSave, onReset, disabled = false }) => {
    return (
        <div className="activation_limit_editor_action_buttons">
            <ActivationLimitEditorButton
                icon={save}
                alt="save changes"
                onClick={onSave}
                disabled={disabled}
                tooltip={
                    <>
                        <div className="tooltip__container_icon">
                            <img
                                src={warning}
                                className="tooltip__warning_svg"
                                alt="warning"
                            />
                        </div>
                        <div className="tooltip__text"> Save changes</div>
                    </>
                }
            />

            <ActivationLimitEditorButton
                icon={refresh}
                alt="refresh"
                onClick={onReset}
                disabled={disabled}
                tooltip={
                    <>
                        <div className="tooltip__container_icon">
                            <img
                                src={warning}
                                className="tooltip__warning_svg"
                                alt="warning"
                            />
                        </div>
                        <div className="tooltip__text">
                            Reset the current changes
                        </div>
                    </>
                }
            />
        </div>
    );
};

export default ActivationLimitEditorActionButtons;
